import React from "react";
import { Target, Eye } from "lucide-react";

const FENCE_IMG =
  "https://images.unsplash.com/photo-1572021335469-31706a17aaef?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85";

const SECTORS = ["Industria", "Infraestructura", "Turismo", "Deportiva"];

const About = () => {
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="relative bg-[#F4F1E8] py-24 md:py-32 border-t-2 border-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="font-mono-tag text-xs text-[#0A0A0A] mb-4">// NOSOTROS</p>

        {/* HEADER + STAT */}
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start mb-16">
          {/* Massive number */}
          <div className="lg:col-span-5">
            <div className="relative">
              <p className="font-display text-[10rem] md:text-[14rem] leading-[0.85] text-[#0A0A0A] tracking-tighter">
                20<span className="text-[#005EB8]">+</span>
              </p>
              <p className="font-mono-tag text-sm text-[#4A4A4A] mt-2">
                AÑOS PROTEGIENDO PERÍMETROS
              </p>
            </div>
            <div className="mt-8 border-2 border-[#0A0A0A] overflow-hidden">
              <img
                src={FENCE_IMG}
                alt="Cerca perimetral metálica"
                className="w-full h-64 object-cover"
              />
            </div>
          </div>

          {/* Text */}
          <div className="lg:col-span-7">
            <h2
              data-testid="about-title"
              className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.9] mb-8 text-[#0A0A0A]"
            >
              ESPECIALISTAS EN
              <span className="text-[#005EB8]"> SEGURIDAD PERIMETRAL</span> Y
              ESTRUCTURAS METÁLICAS.
            </h2>
            <div className="space-y-6 text-[#2A2A2A] text-base md:text-lg leading-relaxed">
              <p>
                En <span className="text-[#0A0A0A] font-semibold">Alambrados Aloma</span>{" "}
                contamos con más de dos décadas fabricando e instalando soluciones
                de seguridad: malla ciclónica, cercas electrificadas, reja de acero,
                alambrados perimetrales y herrería para industria, infraestructura,
                hotelería, deportiva y residencial con cobertura nacional.
              </p>
              <p>
                Nos respaldan proyectos con marcas como{" "}
                <span className="text-[#005EB8] font-semibold">
                  Grupo Vidanta, Four Seasons, St. Regis, Tierra Tropical
                </span>{" "}
                y más, donde la seguridad y el cumplimiento son innegociables.
              </p>
              <p className="border-l-2 border-[#FFF44F] pl-6 italic text-[#0A0A0A] bg-[#FFF44F]/15 py-3">
                "Calidad, precisión y compromiso en cada metro de perímetro."
              </p>
            </div>

            {/* Sectors */}
            <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-0 border-t border-l border-[#0A0A0A]">
              {SECTORS.map((s) => (
                <div
                  key={s}
                  className="border-r border-b border-[#0A0A0A] p-5 hover:bg-[#FFF44F] transition-colors"
                >
                  <p className="font-display text-lg md:text-xl text-[#0A0A0A]">{s}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* MISIÓN + VISIÓN (bento blue) */}
        <div
          data-testid="mission-vision-block"
          className="grid md:grid-cols-2 gap-0 border border-[#2989DD]"
        >
          <div
            data-testid="mission-block"
            className="p-8 md:p-10 border-r-0 md:border-r border-b md:border-b-0 border-[#2989DD] bg-[#005EB8] text-white"
          >
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 border-2 border-[#FFF44F] flex items-center justify-center text-[#FFF44F]">
                <Target size={18} />
              </div>
              <p className="font-mono-tag text-xs text-[#FFF44F]">MISIÓN</p>
            </div>
            <p className="text-zinc-100 leading-relaxed text-sm md:text-base">
              Ofrecer soluciones integrales de alambrados, cercas electrificadas,
              reja de acero y herrería con los más altos estándares de calidad,
              seguridad y precisión. Brindar resultados fiables, funcionales y
              duraderos respaldados por más de dos décadas de experiencia y
              compromiso con la excelencia técnica.
            </p>
          </div>
          <div
            data-testid="vision-block"
            className="p-8 md:p-10 bg-[#0F6CC4] text-white"
          >
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 border-2 border-[#FFF44F] flex items-center justify-center text-[#FFF44F]">
                <Eye size={18} />
              </div>
              <p className="font-mono-tag text-xs text-[#FFF44F]">VISIÓN</p>
            </div>
            <p className="text-zinc-100 leading-relaxed text-sm md:text-base">
              Consolidarnos como la empresa líder a nivel nacional en seguridad
              perimetral, alambrados y herrería metálica, reconocida por la
              calidad, confiabilidad y capacidad de ofrecer soluciones innovadoras
              y precisas. Aspiramos a ser un referente de profesionalismo,
              seguridad y excelencia.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
